import axios from 'axios';

import { axiosHeaderV2, getV2RootUrl } from 'common/helpers/apiHelper';
import { customerId } from 'common/helpers/tokenHelper';

export const listCustomerCreditCards = (queryString) => {
  if (queryString) {
    return axios.get(
      `${getV2RootUrl()}/customer/${customerId()}/credit-card?${queryString}`,
      axiosHeaderV2()
    );
  }
  return axios.get(
    `${getV2RootUrl()}/customer/${customerId()}/credit-card`,
    axiosHeaderV2()
  );
};

export const addCustomerCreditCard = (customerCreditCard) =>
  axios.post(
    `${getV2RootUrl()}/customer/${customerId()}/credit-card/`,
    customerCreditCard,
    axiosHeaderV2()
  );

export const addStripeCustomerCreditCard = (payload) =>
  axios.post(
    `${getV2RootUrl()}/payment/${customerId()}/stripe/credit-card/`,
    payload,
    axiosHeaderV2()
  );

export const addPaystackCustomerCreditCard = (payload) =>
  axios.post(
    `${getV2RootUrl()}/payment/${customerId()}/paystack/credit-card/`,
    payload,
    axiosHeaderV2()
  );

export const editCustomerCreditCard = (
  customerCreditCardId,
  customerCreditCard
) =>
  axios.put(
    `${getV2RootUrl()}/customer/${customerId()}/credit-card/${customerCreditCardId}`,
    customerCreditCard,
    axiosHeaderV2()
  );

export const editStripeCustomerCreditCard = (
  customerCreditCardId,
  customerCreditCard
) =>
  axios.put(
    `${getV2RootUrl()}/payment/${customerId()}/stripe/credit-card/${customerCreditCardId}`,
    customerCreditCard,
    axiosHeaderV2()
  );

export const editPaystackCustomerCreditCard = (customerCreditCardId, payload) =>
  axios.put(
    `${getV2RootUrl()}/payment/${customerId()}/paystack/credit-card/${customerCreditCardId}`,
    payload,
    axiosHeaderV2()
  );

export const deleteCustomerCreditCard = (customerCreditCardId) =>
  axios.delete(
    `${getV2RootUrl()}/customer/${customerId()}/credit-card/${customerCreditCardId}`,
    axiosHeaderV2()
  );
